/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionExposedApi } from '../../models/subscription-exposed-api';

export interface UpsertSubscriptionExposedApiState$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
      body: SubscriptionExposedApi
}

export function upsertSubscriptionExposedApiState(http: HttpClient, rootUrl: string, params: UpsertSubscriptionExposedApiState$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionExposedApi>> {
  const rb = new RequestBuilder(rootUrl, upsertSubscriptionExposedApiState.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionExposedApi>;
    })
  );
}

upsertSubscriptionExposedApiState.PATH = '/custom/subscriptions/{uid}/exposed-api/state';
